import { useState, useEffect } from "react";
import { apiFetch } from "../services/api.js";
import FormCriarCampanha from "../components/FormCriarCampanha.js";
import FormCriarAnual from "../components/FormCriarAnual.js";
import SorteioExecutorSimples from "../components/SorteioExecutorSimples.js";
import HistoricoSorteios from "../components/HistoricoSorteios.js";

export default function Sorteios() {
  const [campanhas, setCampanhas] = useState([]);
  const [anuais, setAnuais] = useState([]);
  const [recarregarKey, setRecarregarKey] = useState(0);

  useEffect(() => {
    carregarDados();
  }, [recarregarKey]);

  async function carregarDados() {
    try {
      const [campanhasRes, anuaisRes] = await Promise.all([
        apiFetch("campanhas"),
        apiFetch("anuais"),
      ]);
      // Filtrar campanhas ativas e não arquivadas
      const campanhasAtivas = (campanhasRes?.campanhas || []).filter(
        (c) => c.ativo !== false && c.arquivado !== true,
      );
      // Filtrar anuais ativos e não arquivados
      const anuaisAtivos = (anuaisRes?.anuais || []).filter(
        (a) => a.ativo !== false && a.arquivado !== true,
      );
      setCampanhas(campanhasAtivas);
      setAnuais(anuaisAtivos);
      console.log("[SORTEIOS] Dados recarregados");
    } catch (err) {
      console.error("[ERRO SORTEIOS]", err);
    }
  }

  function handleSucesso() {
    setRecarregarKey((prev) => prev + 1);
  }

  return (
    <div>
      <div className="container">
        <h2>Sorteios</h2>
        <p>Crie campanhas, anuais (sorteios agrupados) e execute sorteios.</p>
      </div>

      <div className="container">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "2rem",
          }}
        >
          <FormCriarCampanha onSuccess={handleSucesso} />
          <FormCriarAnual campanhas={campanhas} onSuccess={handleSucesso} />
        </div>
      </div>

      <div className="container">
        <SorteioExecutorSimples
          campanhas={campanhas}
          anuais={anuais}
          onSucesso={handleSucesso}
        />
      </div>

      <div className="container">
        <HistoricoSorteios reloadKey={recarregarKey} />
      </div>
    </div>
  );
}
